import { render, staticRenderFns } from "./EmployeeForgotPassword.vue?vue&type=template&id=0323d9b8&"
import script from "./EmployeeForgotPassword.vue?vue&type=script&lang=ts&"
export * from "./EmployeeForgotPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports